import { API_URL } from "../Config/index.js";
import { emitEvent } from "../MasterData/emitter";

// Helper function to get auth token from localStorage
const getAuthToken = () => {
  return localStorage.getItem("authToken");
};

const handleSessionTimeout = (status, data) => {
  if (status === 401 && data?.sessionTimeout) {
    emitEvent("session-timeout", data);
    return true;
  }
  return false;
};

// Add this function with your existing API functions
export const fetchMonthlyPosts = async (monthYear, clientId) => {
  try {
    const token = getAuthToken();
    const response = await fetch(
      `${API_URL}/manage-post/runPost?clientId=${clientId}&DataMonth=${monthYear}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `${token}` } : {}),
        },
      }
    );

    const result = await response.json().catch(() => ({}));

    if (handleSessionTimeout(response.status, result)) {
      return {
        success: false,
        data: [],
        message: result.uiMsg || result.message || "Session timeout",
      };
    }

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    if (result.status && result.data) {
      return {
        success: true,
        data: result.data.posts || [], // Extract posts array from nested data
        totalPosts: result.data.totalPosts,
        dateRange: result.data.dateRange,
        message: result.message,
      };
    }

    return {
      success: false,
      data: [],
      message: result.message || "Failed to fetch monthly posts",
    };
  } catch (error) {
    console.error("Error in fetchMonthlyPosts:", error);
    return {
      success: false,
      data: [],
      message: error.message,
    };
  }
};

export const fetchSafeRunPosts = async (clientId, scheduleDateTime) => {
  try {
    const token = getAuthToken();
    const response = await fetch(
      `${API_URL}/manage-post/safeRun?clientId="${clientId}"&scheduleDateTime="${scheduleDateTime}"`,
      {
        headers: {
          ...(token ? { Authorization: `${token}` } : {}),
        },
      }
    );
    const data = await response.json().catch(() => ({}));
    if (handleSessionTimeout(response.status, data)) {
      return {
        success: false,
        message: data.uiMsg || data.message || "Session timeout",
      };
    }
    if (!response.ok) throw new Error("Failed to fetch posts");
    return { success: true, data: data.data };
  } catch (error) {
    return { success: false, message: error.message };
  }
};

// Approve post function
export const approvePost = async (scheduleDateTime, clientId) => {
  try {
    const token = getAuthToken();
    const response = await fetch(`${API_URL}/manage-post/Approve`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `${token}` } : {}),
      },
      body: JSON.stringify({
        scheduleDateTime,
        clientId,
      }),
    });

    const data = await response.json();

    if (handleSessionTimeout(response.status, data)) {
      return {
        success: false,
        message: data.uiMsg || data.message || "Session timeout",
        error: data,
      };
    }

    if (response.ok) {
      return {
        success: true,
        data: data,
        message: "Post approved successfully",
      };
    } else {
      return {
        success: false,
        message: data.message || "Failed to approve post",
        error: data,
      };
    }
  } catch (error) {
    console.error("Error approving post:", error);
    return {
      success: false,
      message: "Network error occurred while approving post",
      error: error.message,
    };
  }
};

// Reject post function
export const rejectPost = async (scheduleDateTime, clientId) => {
  try {
    const token = getAuthToken();
    const response = await fetch(`${API_URL}/manage-post/Rejected`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `${token}` } : {}),
      },
      body: JSON.stringify({
        scheduleDateTime,
        clientId,
      }),
    });

    const data = await response.json();

    if (handleSessionTimeout(response.status, data)) {
      return {
        success: false,
        message: data.uiMsg || data.message || "Session timeout",
        error: data,
      };
    }

    if (response.ok) {
      return {
        success: true,
        data: data,
        message: "Post rejected successfully",
      };
    } else {
      return {
        success: false,
        message: data.message || "Failed to reject post",
        error: data,
      };
    }
  } catch (error) {
    console.error("Error rejecting post:", error);
    return {
      success: false,
      message: "Network error occurred while rejecting post",
      error: error.message,
    };
  }
};
